import { isGraphPointer, isLiteral } from 'is-graph-pointer';
import { xsd } from '@tpluscode/rdf-ns-builders';
import { sh } from '@tpluscode/rdf-ns-builders/loose';
import { fromRdf } from 'rdf-literal';
import { getOne } from './util.js';
import { SubselectExpression } from './SubselectExpression.js';
export class OffsetExpression extends SubselectExpression {
    static match(pointer) {
        return isLiteral(pointer.out(sh.offset), xsd.integer) && isGraphPointer(pointer.out(sh.nodes));
    }
    static fromPointer(pointer, fromNode) {
        const offset = pointer.out(sh.offset);
        if (!isLiteral(offset) || !offset.term.datatype.equals(xsd.integer)) {
            throw new Error('sh:offset must be an xsd:integer');
        }
        return new OffsetExpression(pointer.term, fromRdf(offset.term, true), fromNode.nodeExpression(getOne(pointer, sh.nodes)));
    }
    constructor(term, offset, nodes) {
        super(term, nodes);
        this.offset = offset;
    }
    _applySubselectClause(select) {
        return {
            ...select,
            offset: this.offset,
        };
    }
}
